import { map } from 'lodash';
import moment from 'moment';

class PeriodsFormController {
  constructor($rootScope, $scope, $state, periodsService, messageService) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.periodsService = periodsService;
    this.messageService = messageService;
  }

  $onInit() {
    this.period = this.period || { pricing: []};
    this.period.start = (this.period.start)? moment(this.period.start, 'YYYY-MM-DD') : '';
    this.period.end = (this.period.end)? moment(this.period.end, 'YYYY-MM-DD') : '';
    this.period.property_id = this.$rootScope.currentProperty.id;

    this.$scope.$watch(() => this.period.start,
        (newVal, oldVal, $scope) => {
            if (newVal !== oldVal && typeof newVal === 'object'){
                $scope.$ctrl.autoName();
            }
        },
        true
    );
    this.$scope.$watch(() => this.period.end,
        (newVal, oldVal, $scope) => {
            if (newVal !== oldVal && typeof newVal === 'object'){
                $scope.$ctrl.autoName();
            }
        },
        true
    );
  }

  onSave() {
    if ( this.period.start ) {
      this.period.start = this.period.start.format('YYYY-MM-DD');
    }

    if ( this.period.end && typeof this.period.end !== 'boolean') {
      this.period.end = this.period.end.format('YYYY-MM-DD');
    }

    return this.periodsService.save(this.period)
      .then(response => {
        if (this.period.id) {
          this.messageService.success(`The period <strong>${this.period.name}</strong> was successfully updated!`, [`app.admin.period-edit({ 'period' : ${this.period.id}})`, `Period`]);
          this.$state.go('app.admin.periods');
        }else{
          this.messageService.success(`The period <strong>${response.name}</strong> was successfully created.`);
          this.$state.go('app.admin.period-edit', {period: response.id, tab: 'pricing'});
        }
      })
      .catch((error) => {
        error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

        let sourceElement = Object.keys(error.data);
        let verb = 'created';
        if ( this.period.id ) {
          verb = 'updated';
        }
        if ( sourceElement.length > 0 ) {
          let errors = '';
          for ( let element of sourceElement ) {
            errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
          }
          this.messageService.failure(`The period <strong>${this.period.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
        } else {
          this.messageService.failure(`The period <strong>${this.period.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
        }
        this.messageService.push();
      });
  }

  autoName() {
      if ( !this.period.custom_name ) {
        if ( typeof this.period.start === 'object' ) {
          this.period.name = this.period.start.format('Do MMMM (YYYY)') + ' to ';

          if ( typeof this.period.end === 'object' || !this.period.end ) {
            if ( this.period.end && this.period.end.isValid() ) {
                this.period.name += this.period.end.format('Do MMMM (YYYY)');
            } else {
              this.period.name += 'indefinite';
            }
          }
        } else {
          this.period.name = '';
        }
      }
  }

  toggleAutoName() {
    if ( !this.period.custom_name ) {
      this.autoName();
    }
  }

  clearDate(model) {
    model = undefined;
    this.autoName();
  }
}

PeriodsFormController.$inject = [ '$rootScope', '$scope', '$state', 'periodsService', 'messageService' ];

export default PeriodsFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/controllers/periods.form.controller.js